var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c('div',{staticClass:"dialog-tips"},[_c('div',{staticStyle:{"margin":"0 auto","width":"100%"}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }